import { findAll, find } from '@fretadao/f-js-dom';

export default class DataTableView{
  constructor({ manager, rowRenderer }){
    this.manager = manager;
    this.rowRenderer = rowRenderer;
  }

  buildColumns(columns){
    return columns.map(function(column){
      return {
        name: column,
        sortable: false,
        dropdown: false,
      }
    });
  }

  showTableContainer(){
    let container = find('.row-management-container');

    if(container !== undefined){
      container.classList.remove('batch-hidden');
      container.classList.add('batch-visible');
    }
  }

  highlightFaultyRows(){
    let invalidCells          = findAll(`.${this.rowRenderer.invalidCellClassName}`);
    let invalidRows           = invalidCells.map((cellElem) => cellElem.closest('.dt-row'));
    let invalidCellContainers = invalidCells.map((cellElem) => cellElem.closest('.dt-cell'));
    invalidRows.forEach((elem) => elem.classList.add(this.rowRenderer.invalidRowClassName));
    this.highLightCellContainers(invalidCellContainers);
    this.updateFaultyLinesQuantity(this.rowRenderer.invalidRowClassName);
  }

  highLightCellContainers(invalidCellContainers){
    invalidCellContainers.forEach((elem) => {
      elem.classList.add(this.rowRenderer.invalidCellContainerClassName)
      elem.dataset['tooltip'] = this.rowRenderer.tooltipText;
    });
  }

  setFileSize(bytesSize){
    let fileSizeElem = find('div.file-details span.size');

    let kbSize = (bytesSize / (1024)).toFixed(2);
    fileSizeElem.textContent = `${kbSize} kb`;
  }

  cellEditor(){
    let dataTableView = this;

    return (colIndex, rowIndex, cellValue, editNode, column, row, data) => {

      let rowInfo = dataTableView.buildRowInfo(row);
      let fieldEditElement = dataTableView.buildEditElement(editNode);

      return {
        initValue(value) {
          fieldEditElement.focus();
          fieldEditElement.value = value;
        },
        getValue() {
          return fieldEditElement.value;
        },
        setValue(value) {
          fieldEditElement.value = value;

          rowInfo[column.content] = value;
          dataTableView.manager.rebuild(rowInfo, rowIndex);

          document.dispatchEvent(new Event('batch-upload:rebuild'));
        }
      }
    }
  }

  buildRowInfo(rowData){
    return rowData.slice(1).reduce((rowInfo, cell) => {
      return {
        ...rowInfo,
        [cell.column.name]: cell.content
      }
    }, {});
  }

  buildEditElement(parentNode){
    let fieldEditElement = document.createElement('input', { type: 'text' });
    fieldEditElement.classList.add('dt-input');
    fieldEditElement.type = 'text';
    parentNode.appendChild(fieldEditElement);

    return fieldEditElement;
  }

  updateFaultyLinesQuantity(invalidRowClassName){
    let invalidRows  = findAll(`.${invalidRowClassName}`);
    let quantityElem = find('div.faulty-lines span.quantity');
    quantityElem.textContent = invalidRows.length;
  }
}
